import { render, staticRenderFns } from "./JOBFUN.vue?vue&type=template&id=4bf7f516&"
import script from "./JOBFUN.vue?vue&type=script&lang=js&"
export * from "./JOBFUN.vue?vue&type=script&lang=js&"
import style0 from "./JOBFUN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports